import { AvailableWriteProviders, EWalletId } from '@ankr.com/provider';
import { MultiRpcWeb3Sdk, MultiRpcSdk, configFromEnv } from 'multirpc-sdk';
import { t } from '@ankr.com/common';

import { API_ENV } from 'modules/common/constants/env';

import { ProviderManagerSingleton } from './ProviderManagerSingleton';
import { getProviderManager } from './getProviderManager';
import { getEthReadProviderID } from './utils/getEthReadProviderID';

const INJECTED_WALLET_ID = EWalletId.injected;

export const CONFIG = configFromEnv(API_ENV);

export class MultiService {
  private static web3Service?: MultiRpcWeb3Sdk;

  private static service?: MultiRpcSdk;

  // createInstance in connect action
  public static async createWeb3Service(
    walletId: string,
  ): Promise<MultiRpcWeb3Sdk> {
    const providerManager = getProviderManager();

    const writeProvider = await providerManager.getETHWriteProvider(walletId);

    const readProvider = await providerManager.getETHReadProvider(
      getEthReadProviderID(),
    );

    if (walletId !== INJECTED_WALLET_ID) {
      MultiService.removeServices();

      throw new Error(t('error.not-supported-wallet'));
    }

    MultiService.web3Service = new MultiRpcWeb3Sdk(
      writeProvider,
      readProvider,
      CONFIG,
    );

    return MultiService.web3Service;
  }

  public static getWeb3Service() {
    return MultiService.web3Service;
  }

  public static removeServices() {
    MultiService.web3Service = undefined;
    ProviderManagerSingleton.getInstance().disconnect(
      AvailableWriteProviders.ethCompatible,
    );

    ProviderManagerSingleton.removeInstance();
    MultiService.service = undefined;
  }

  public static removeWeb3Services() {
    MultiService.web3Service = undefined;
    ProviderManagerSingleton.getInstance().disconnect(
      AvailableWriteProviders.ethCompatible,
    );

    ProviderManagerSingleton.removeInstance();
  }

  // use getService for methods without web3 connect
  public static getService(): MultiRpcSdk {
    if (!MultiService.service) {
      MultiService.service = new MultiRpcSdk(CONFIG);
    }

    return MultiService.service;
  }
}
